/**
 * La inicial que muestra un avatar cuando no hay foto: la del **nombre**, si no la del **correo**,
 * y si no un signo de pregunta.
 *
 * ── POR QUÉ EXISTE ──────────────────────────────────────────────────────────
 *
 * Estaba escrita **doce veces en seis formas distintas**, y la mitad **tira** cuando el dato falta:
 *
 * | Forma | ¿Aguanta el dato ausente? |
 * | --- | --- |
 * | `p.name?.[0] ?? p.email?.[0] ?? '?'` | ✅ |
 * | `user?.name[0] ?? user?.email[0]` | ❌ el `?.` protege al USUARIO, no al nombre |
 * | `advisor.fullname[0]` | ❌ |
 * | `name ? name[0] : email[0]` | ⚠️ aguanta el nombre, no el correo |
 * | `comment.authorName[0] ?? '?'` | ❌ el `??` protege al CARÁCTER, no al nombre |
 *
 * La última es la más engañosa: parece defendida y no lo está. `authorName[0]` se evalúa **antes**
 * del `??`, así que con `authorName` ausente tira sin llegar nunca al `'?'`.
 *
 * Y esto se renderiza: un `undefined[0]` acá **rompe el render de React**, no deja un hueco. La
 * pantalla entera se cae por una inicial.
 *
 * ── LA CADENA, Y POR QUÉ TERMINA EN `'?'` ───────────────────────────────────
 *
 * Un avatar sin inicial es un círculo vacío que parece un error de carga. El signo de pregunta
 * dice «no sé quién es», que es la verdad. Los espacios se recortan antes: un nombre de puros
 * espacios daría una inicial en blanco, que es el círculo vacío otra vez —la misma trampa que
 * `buildResolvedSigners` ya cerró para las firmas.
 */
export function avatarInitial({
  name,
  email
}: {
  name?: string | null
  email?: string | null
}): string {
  const fromName = name?.trim()?.[0]
  if (fromName) return fromName.toUpperCase()

  const fromEmail = email?.trim()?.[0]
  if (fromEmail) return fromEmail.toUpperCase()

  return '?'
}
